import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle, faTimes } from "@fortawesome/free-solid-svg-icons";
import styles from './ErrorModal.module.css';

/**
 * Модальное окно для отображения ошибок от бэкенда
 * @param {boolean} show - Показать/скрыть модальное окно
 * @param {string|Array} error - Текст ошибки или массив ошибок
 * @param {string} title - Заголовок модального окна
 * @param {Function} onClose - Функция закрытия модального окна
 */
const ErrorModal = ({ show, error, title = 'Ошибка', onClose }) => {
    // Обработка разных форматов ошибок
    let errorMessage = '';
    let errorList = [];

    if (typeof error === 'string') {
        errorMessage = error;
    } else if (Array.isArray(error)) {
        errorList = error;
        errorMessage = error.length > 0 ? error[0] : 'Произошла ошибка';
    } else if (error && typeof error === 'object') {
        // Обработка ответа от бэкенда {success: false, error: "...", errors: [...]}
        if (error.error) {
            errorMessage = error.error;
        }
        if (error.errors && Array.isArray(error.errors)) {
            errorList = error.errors;
        }
    }

    // Предотвращаем скролл body когда модалка открыта
    useEffect(() => {
        if (show) {
            document.body.style.overflow = 'hidden';
            return () => {
                document.body.style.overflow = '';
            };
        }
    }, [show]);

    if (!show) return null;

    const modalContent = (
        <>
            <div className={styles.Backdrop} onClick={onClose} />
            <div className={styles.Modal} role="dialog" aria-modal="true">
                <div className={styles.ModalDialog}>
                    <div className={styles.ModalContent}>
                        <div className={styles.ErrorModalHeader}>
                            <div className={styles.ErrorModalTitle}>
                                <FontAwesomeIcon icon={faExclamationTriangle} className={styles.ErrorIcon} />
                                {title}
                            </div>
                            <button 
                                type="button"
                                onClick={onClose}
                                className={styles.CloseButton}
                                aria-label="Закрыть"
                            >
                                <FontAwesomeIcon icon={faTimes} />
                            </button>
                        </div>
                        <div className={styles.ErrorModalBody}>
                            {errorMessage && errorList.length === 0 && (
                                <div className={styles.ErrorMessage}>
                                    {errorMessage}
                                </div>
                            )}
                            {errorList.length > 0 && (
                                <ul className={styles.ErrorList}>
                                    {errorList.map((err, index) => (
                                        <li key={index}>{err}</li>
                                    ))}
                                </ul>
                            )}
                            {errorMessage && errorList.length > 0 && errorMessage !== errorList[0] && (
                                <div className={styles.ErrorMessage} style={{marginTop: '1rem'}}>
                                    {errorMessage}
                                </div>
                            )}
                        </div>
                        <div className={styles.ErrorModalFooter}>
                            <button type="button" className={styles.PrimaryButton} onClick={onClose}>
                                Понятно
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );

    return createPortal(modalContent, document.body);
};

export default ErrorModal;

